<template>
  <div>
    <VTableLocal
      v-if="getItems"
      :iconHeader="null"
      :items="getItems"
      :isSearchable="false"
      :isSelectable="false"
      :disablePagination="true"
      :headers="tableHeaders"
      :showRowIcon="false"
    >
      <template #item.result="{ item }">
        <div class="result-box">
          <span
            class="dot"
            :class="item.color ? item.color : ''"
          />
          <span class="alert-table-measure">
            {{ item.value }}
          </span>
        </div>
        <span class="minMax">
          {{ item.min }} - {{ item.max }}
        </span>
      </template>
      <template #item.quantity="{ item }">
        <div class="result-box">
          <span
            class="dot"
            :class="item.color ? item.color : ''"
          />
          <span class="alert-table-measure">
            {{ item.quantity }}
          </span>
        </div>
        <span class="minMax">
          {{ $t('forms.labels.min') }} - {{ item.max }}
        </span>
      </template>
      <template #item.product="{ item }">
        <span>
          {{ item.product }}, {{ item.location }}, {{ item.container }}
        </span>
      </template>
    </VTableLocal>
  </div>
</template>

<script>
import VTableLocal from '@/components/shared/content-views/VTableLocal';

export default {
    components: {
        VTableLocal,
    },
    props: {
        alertId: {
            type: String,
            default: '',
        },
        type: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            loading: false,
            alerts: {
                analysisData: [],
                inventoryData: [],
            },
        };
    },
    computed: {
        tableHeaders() {
            const analysisHeaders = [
                {
                    text: this.$t('forms.labels.result'),
                    value: 'result',
                    sortable: false,
                },
                {
                    text: this.$t('forms.labels.analysis'),
                    value: 'analysis',
                    sortable: false,
                },
                {
                    text: this.$t('forms.labels.notes'),
                    value: 'notes',
                    sortable: false,
                },
                {
                    text: this.$t('forms.labels.siteName'),
                    value: 'siteName',
                    sortable: false,
                },
                {
                    text: this.$t('forms.labels.siteNumber'),
                    value: 'siteNumber',
                    sortable: false,
                },
                {
                    text: this.$t('forms.labels.woNumber'),
                    value: 'woNumber',
                    sortable: false,
                },
                {
                    text: this.$t('forms.labels.network'),
                    value: 'network',
                    sortable: false,
                },
                {
                    text: this.$t('forms.labels.component'),
                    value: 'component',
                    sortable: false,
                },
            ];

            const inventoryHeader = [
                {
                    text: this.$t('forms.labels.quantity'),
                    value: 'quantity',
                    sortable: false,
                },
                {
                    text: this.$t('forms.labels.productInventory'),
                    value: 'product',
                    sortable: false,
                },
                {
                    text: this.$t('forms.labels.siteName'),
                    value: 'siteName',
                    sortable: false,
                },
                {
                    text: this.$t('forms.labels.siteNumber'),
                    value: 'siteNumber',
                    sortable: false,
                },
                {
                    text: this.$t('forms.labels.woNumber'),
                    value: 'woNumber',
                    sortable: false,
                },
            ];

            return this.isAnalysis() ? analysisHeaders : inventoryHeader;
        },
        getItems() {
            return this.isAnalysis() ? this.alerts.analysisData : this.alerts.inventoryData;
        },
    },
    watch: {
        alertId: {
            handler() {
                this.loadData();
            },
            deep: true,
        },
    },
    async created() {
        await this.loadData();
    },
    methods: {
        isAnalysis() {
            return this.type === 'Analysis';
        },
        async loadData() {
            const { data } = await this.$rq.getNotification(this.alertId);
            this.alerts.analysisData = data.analysisData?.map((currentAlert, index) => ({
                id: index,
                min: currentAlert.norm.minimum,
                max: currentAlert.norm.maximum,
                value: currentAlert.measuredValue,
                analysis: currentAlert.analysisType.name,
                notes: currentAlert.note,
                siteName: data.site.name,
                siteNumber: data.site.deliveryAccountNumber,
                woNumber: data.workOrder.contractNumber,
                network: currentAlert.network.name,
                component: currentAlert.component.name,
                color: currentAlert.dotColor,
            }));

            this.alerts.inventoryData = data.inventoryData?.map((currentAlert, index) => ({
                id: index,
                quantity: currentAlert.measuredQuantity,
                max: currentAlert.alertQuantityMin,
                product: currentAlert.productInventory.product.name,
                location: currentAlert.productInventory.location,
                container: currentAlert.productInventory.container,
                siteName: data.site.name,
                siteNumber: data.site.deliveryAccountNumber,
                woNumber: data.workOrder.contractNumber,
                color: currentAlert.dotColor,
            }));
        },
    },
};
</script>
<style lang="scss" scoped>
    .date {
        margin-bottom: 0px;
        .label {
            font-weight: bold;
        }
    }
    .dot {
        height: 14px;
        width: 14px;
        border-radius: 50%;
        display: inline-block;
        margin-right: 7px;
    }
    .red {
        background-color: #ad1c3f;
    }
    .green {
        background-color: #2a750f;
    }
    .yellow {
        background-color: #d1a918;
    }
    .orange {
        background-color: #ff9800;
    }
    .result-box {
        display: flex;
        align-items: baseline;
    }
    .result-row {
        box-shadow: 0px 2px 3px #cccccc;
    }
    .result-content {
        text-align: center;
        padding: 15px;
    }
    .minMax {
        font-size: 12px;
    }
</style>
